import { gql } from '@apollo/client';

const ITEMS_FIELDS = gql`
  fragment ItemsFields on BibliographicRecord {
    physicalManifestations {
      aggregate {
        count
      }
    }
  }
`;

export const getRelatedBibsQuery = ({ fetchItems }) => {
  const query = gql`
    ${fetchItems ? ITEMS_FIELDS : ''}
    query fetchRelatedBibs(
      $where: searchBibliographicRecordInput
      $first: Int
      $skip: Int
    ) {
      searchBibliographicRecord(where: $where, first: $first, skip: $skip) {
        nodes {
          guid
          title
          author
          publisher
          releaseDate
          type
          publicationPlace
          rawMarcRecord
          ${fetchItems ? '...ItemsFields' : ''}

          publicFiles {
            isProtected
            classification
            displayName
            publicUrl
            protectedUrl
          }
        }
      }
    }
  `;

  return query;
};

export const FETCH_RELATED_BIBS_COUNT = gql`
  query fetchRelatedBibCount($where: searchBibliographicRecordInput) {
    searchBibliographicRecord(where: $where) {
      aggregate {
        count
      }
    }
  }
`;
